import type { PhysicalStepData, PhysicalStepRequest } from './models';

import { saveOnboardingStep } from './onboarding-step';

const savePhysicalStep = saveOnboardingStep<
  PhysicalStepData,
  PhysicalStepRequest
>('No se pudo guardar el paso');

export const createPhysicalPersonalData = (body: PhysicalStepRequest) =>
  savePhysicalStep('post', '/onboarding/personal/data', body);

export const updatePhysicalPersonalData = (body: PhysicalStepRequest) =>
  savePhysicalStep('put', '/onboarding/personal/data', body);

export const updatePhysicalEconomicInformation = (body: PhysicalStepRequest) =>
  savePhysicalStep('put', '/onboarding/economic/information', body);

export const createPhysicalBankAccount = (body: PhysicalStepRequest) =>
  savePhysicalStep('post', '/onboarding/account', body);

export const updatePhysicalBankAccount = (body: PhysicalStepRequest) =>
  savePhysicalStep('put', '/onboarding/account', body);

export const createPhysicalBeneficiary = (body: PhysicalStepRequest) =>
  savePhysicalStep('post', '/onboarding/beneficiary', body);

export const updatePhysicalBeneficiary = (body: PhysicalStepRequest) =>
  savePhysicalStep('put', '/onboarding/beneficiary', body);

export const updatePhysicalInvestmentAccount = (body: PhysicalStepRequest) =>
  savePhysicalStep('put', '/onboarding/investment/account', body);

export const updatePhysicalInvestmentAccountMoral = (
  body: PhysicalStepRequest,
) => savePhysicalStep('put', '/onboarding/investment/account/moral', body);
